import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileUploadDialogData, PDFReportInformation } from 'src/app/core';
import { FilesService } from 'src/app/feature/services/files.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { firstValueFrom, Subscription } from 'rxjs';
import { SubSink } from 'subsink';

@Component({
  selector: 'public-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @Output('file') fileUpload: EventEmitter<PDFReportInformation> =
    new EventEmitter();

  @Output('status') statusEvent: EventEmitter<string> = new EventEmitter();
  @Input('isDocSharing') isDocSharing: boolean = false;

  @Input() name!: string;

  @Input('information') information!: PDFReportInformation;
  @Output('informationChange')
  informationChange: EventEmitter<PDFReportInformation> = new EventEmitter();

  private sink: SubSink = new SubSink();

  private _subscriptions: Subscription[] = [];
  private set subscriptions(subscription: Subscription | undefined) {
    if (subscription) {
      this._subscriptions.push(subscription);
    }
  }

  public fileUploading: boolean = false;
  public isFileUploaded: boolean = false;
  public isRangesSelected: boolean = false;

  public fileUploadingProgress!: number;
  public uploadFileReport!: PDFReportInformation;

  constructor(
    private fileService: FilesService,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit(): void {}

  public sendResultBack() {
    const data: FileUploadDialogData = {
      immediate: true,
      acceptableTypes: ['application/pdf'],
      urlName: 'uploadOrder',
      name: this.name,
    };

    firstValueFrom(
      this.fileService.openFileUploadDialog<PDFReportInformation>({ data })
    ).then((data) => {
      this.fileUploading = false;

      if (data) {
        this.isFileUploaded = true;
        this.uploadFileReport = data;
        
        this.fileService.uploadedFile = data;
        this.fileService.uploadedStatus = `تعداد صفحات: ${data.numpages} صفحه`

        this.statusEvent.emit(this.fileService.uploadedStatus);
        this.fileUpload.emit(this.fileService.uploadedFile);
      }
    });
  }

  openDefaultSnackbar(message: string, duration?: number) {
    this.snackbar.open(message, 'باشه !', { duration: duration || 1000 });
  }

  generateFileUploadStatus(percent: number): string {
    const message = 'در حال آپلود: ' + percent + '%';
    return message;
  }
}
